var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.count > 1 && !_vm.sample
      ? _c(
          "div",
          { staticClass: "projects-filters" },
          _vm._l(_vm.categories, function(c) {
            return _c(
              "a",
              {
                staticClass: "button mod-filter",
                class: { active: _vm.catID === c.cat_ID },
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.setActive(c.cat_ID)
                  }
                }
              },
              [_vm._v(_vm._s(c.name))]
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "projects-f" },
      [
        _vm._l(_vm.display, function(d) {
          return _c(
            "div",
            {
              key: d.id,
              ref: "project",
              refInFor: true,
              staticClass: "project ani-projects-custom-all",
              class: { "is-new": d.isNew },
              style: { backgroundImage: _vm.bgImage(d) }
            },
            [
              _c("a", { staticClass: "block", attrs: { href: d.link } }),
              _vm._v(" "),
              _c("div", { staticClass: "project-mask" }),
              _vm._v(" "),
              _c("div", { staticClass: "project-d" }, [
                _c("div", { staticClass: "project-d-view" }, [
                  _c(
                    "a",
                    {
                      staticClass: "button port w-button",
                      attrs: { href: d.link }
                    },
                    [_vm._v("View project")]
                  ),
                  _vm._v(" "),
                  _c("h3", [_vm._v(_vm._s(d.post_title))])
                ]),
                _vm._v(" "),
                _c("p", { domProps: { innerHTML: _vm._s(d.acf.excerpt) } })
              ])
            ]
          )
        }),
        _vm._v(" "),
        _c("div", { staticClass: "loader", class: { loading: _vm.loading } })
      ],
      2
    ),
    _vm._v(" "),
    _vm.isMore && !_vm.sample
      ? _c("div", { staticClass: "page-action" }, [
          _c(
            "a",
            {
              staticClass: "button mod-load-more active",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.loadMore()
                }
              }
            },
            [_vm._v("Load more")]
          )
        ])
      : _vm.sample
      ? _c("div", { staticClass: "page-action" }, [
          _c(
            "a",
            { staticClass: "button w-button", attrs: { href: "/portfolio" } },
            [_vm._v("See our full portfolio")]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }